<template>
  <div class="k-content">
    <div class="list">
      <div class="title">BRCA1/2基因致病或可能致病突变</div>
      <div class="show-box"></div>
      <div class="byData" v-for="(item, index) in currentPageData" :key="index">
        <h2>
          {{ item.geneName }}
        </h2>
        <div class="flex-content">
          <div class="l">
            <div>
              <p>致病风险</p>
              <van-tag
                :color="color[item.genetronInfChinese]"
                :text-color="textColor[item.genetronInfChinese]"
                size="medium"
                >{{ item.genetronInfChinese }}</van-tag
              >
            </div>
            <div>
              <p>氨基酸</p>
              <h3>{{ item.proteinChange }}</h3>
            </div>
          </div>
          <div class="r">
            <div>
              <p>核苷酸</p>
              <h3>{{ item.cdnaChange }}</h3>
            </div>
            <div>
              <p>纯合/杂合</p>
              <h3>{{ item.homHetChinese }}</h3>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="screen">
      <h2>可匹配靶向药物：</h2>
      <p @click="isByShow = true">
        {{screenText}}
        <i
          class="iconfont"
          :class="isByShow ? 'icon-shangsanjiao' : 'icon-xiasanjiao'"
        ></i>
      </p>
    </div>
    <div class="cancer-box">
      <div class="title">获批癌种</div>
      <div class="show-box"></div>
      <div class="text">卵巢癌、输卵管癌、原发性腹膜癌</div>
    </div>
    <div class="cancer-box tab-box">
      <div class="title">获批癌种</div>
      <div class="show-box"></div>
      <van-tabs v-model="active">
        <van-tab title="标签 1">
          <div class="text">
            体细胞突变）的晚期上皮性卵巢癌、输卵管癌或原发性腹膜癌成人患者的维持治疗
          </div>
        </van-tab>
        <van-tab title="标签 2">
          <div class="text">
            用于经一线以铂类为基础的化疗治疗后获得完全或部分缓解、携带
            有害突变或疑似有害突变（胚系突变
            体细胞突变）的晚期上皮性卵巢癌、输卵管癌或原发性腹膜癌成人患者的维持治疗
          </div>
        </van-tab>
      </van-tabs>
    </div>
    <!-- 筛选弹框 -->
    <template>
      <van-popup
        v-model="isByShow"
        round
        closeable
        position="bottom"
        :style="{ height: '50%' }"
      >
        <div class="select-list">
          <p
            @click="handleList(item)"
            v-for="(item, index) in selectData"
            :key="index"
          >
            {{ item.name }}
          </p>
        </div>
      </van-popup>
    </template>
  </div>
</template>

<script>
export default {
  data() {
    return {
      active: 1,
      isByShow: false,
      screenText:'奥拉帕里1',
      selectData: [
        { name: "奥拉帕里1" },
        { name: "奥拉帕里2" },
        { name: "奥拉帕里3" },
      ],
      currentPageData: [
        {
          homHetChinese: 1,
          cdnaChange: "adasdsa",
          proteinChange: "12312aasd",
          genetronInfChinese: "可能致病",
          geneName: "EGFR",
        },
      ],
      color: {
        致病: "#FFF0F3",
        可能致病: "#FFF8EE",
        意义不明: "#EFEAFF",
      },
      textColor: {
        致病: "#FF627F",
        可能致病: "#FFB026",
        意义不明: "#7C67E6",
      },
    };
  },
  methods: {
    handleList(item) {
      this.screenText = item.name;
      this.isByShow = false;
      
    },
  },
};
</script>

<style lang="less" scoped>
.select-list {
  height: 70%;
  box-sizing: border-box;
  margin-top: 50px;
  padding: 0 24px;
  overflow-y: scroll;
  p {
    font-size: 13px;
    color: #2f354d;
    margin-bottom: 20px;
    &:active{
      color: #4B84FF;
    }
  }
}
.k-content {
  padding: 0 16px;
  .tab-box {
    /deep/.van-tabs--line .van-tabs__wrap {
      margin-bottom: 20px;
      height: auto;
      padding-right: 120px;
      margin-top: 10px;
      .van-tabs__line {
        width: 24px;
        height: 3px;
        background: #4b84ff;
        border-radius: 2px;
      }
    }
    /deep/.van-tabs__nav {
      background: none;
      padding-bottom: 20px !important;
    }
  }
  .cancer-box {
    background: @background_color;
    border-radius: 10px;
    padding-bottom: 24px;
    margin-bottom: 16px;
    .text {
      padding: 0 24px;
      font-size: 15PX;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #5f697d;
      line-height: 30px;
    }
  }
  .screen {
    display: flex;
    align-items: center;
    padding: 24px 0 16px;
    h2 {
      font-size: 13px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #2f354d;
    }
    p {
      color: #4b84ff;
      font-size: 13px;

      i {
        font-size: 12px;
      }
    }
  }
  .title {
    height: 70px;
    font-size: 18PX;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #2f354d;
    line-height: 70px;
    padding-left: 24px;
  }
  .show-box {
    height: 20px;
    background: linear-gradient(
      360deg,
      rgba(58, 74, 134, 0) 0%,
      rgba(58, 74, 134, 0.06) 100%
    );
  }
  .list {
    background: @background_color;
    border-radius: 10px;
  }
}
.byData {
  border-bottom: 1px solid #e3e5e8;
  margin-bottom: 30px;
  padding: 0 24px;
  &:last-child {
    border: 0;
    margin: 0;
  }

  .flex-content {
    display: flex;
    .l,
    .r {
      width: 50%;
    }
    .l {
      div {
        margin-bottom: 20px;
      }
    }
    .r {
      div {
        margin-bottom: 26px;
      }
    }
    p {
      font-size: 12px;
      font-weight: 400;
      color: #a4a9bf;
      line-height: 17px;
      margin-bottom: 4px;
    }
    h3 {
      font-size: 13px;
      font-weight: 500;
      color: #2f354d;
      line-height: 18PX;
    }
  }
  h2 {
    font-size: 15PX;
    font-weight: 500;
    color: #27ca8d;
    line-height: 22px;
    position: relative;
    padding-left: 16px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 20px;
    span {
      font-size: 12px;
      font-weight: 400;
      color: #4b84ff;
      line-height: 17px;
      i {
        margin-left: 4px;
        vertical-align: middle;
        margin-bottom: 3px;
      }
    }
    &::before {
      content: "";
      position: absolute;
      top: 50%;
      margin-top: -7px;
      left: 0;
      width: 3px;
      height: 14px;
      background: #27ca8d;
      border-radius: 2px;
    }
  }
}
</style>>
